// The AI Suggestion panel's notice for a turn waiting on a TRQ retry
// (2026-10-14, prod contact 7288740). The order is not in TRQ yet, so the
// pipeline deferred the turn (status 'waiting', waiting_reason 'trq_retry')
// and persisted no suggestion; CXHub tries again at the due time. Shown after
// a Regenerate or a step's refresh comes back deferred (the 202 from
// POST /api/ai/conversations/:id/suggest), and whenever such a contact is
// opened, from its stored due time and attempt count. Never the "already
// answered" notice, which is for a conversation whose latest message is ours.
//
// deferral: { dueAt, attempt, maxAttempts } from the 202, or null.
// conversation: { status, waitingReason, dueAt, attempt, maxAttempts }.
// Returns the notice text, or null when neither applies.
export function trqRetryNotice({ deferral = null, conversation = null, formatTime = defaultFormatTime } = {}) {
  const source = deferral
    ?? (conversation?.status === 'waiting' && conversation?.waitingReason === 'trq_retry'
      ? { dueAt: conversation.dueAt, attempt: conversation.attempt, maxAttempts: conversation.maxAttempts }
      : null)
  if (!source) return null
  const when = source.dueAt ? formatTime(source.dueAt) : 'shortly'
  const of = source.attempt != null && source.maxAttempts != null ? ` (attempt ${source.attempt} of ${source.maxAttempts})` : ''
  return `Order not found in TRQ yet. CXHub will try again at ${when}${of}. The suggestion below is from the previous attempt.`
}

function defaultFormatTime(iso) {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}
